/* eslint-disable arrow-body-style */
import React from 'react'

const BaseDiv = ({ style, children }) => (
  <div style={style}>
    {children}
  </div>
)

const Div = ({
  renderElement,
  renderChildren,
  ...props,
}) => {
  return (
    renderElement(
      BaseDiv,
      { ...props, children: renderChildren() },
    )
  )
}

Div.propTypes = {}
Div.defaultProps = {}

export default Div



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/Div.js